import { Pipe, PipeTransform } from '@angular/core';
import {UserGroupInterface} from '@app/03-modules/user-groups/interfaces/user-group.interface';
import {DataService} from '@app/02-core/services';
import {UserInterface} from '@app/03-modules/users/interfaces/user.interface';

@Pipe({ name: 'bytesConvert' })
export class BytesConvertPipe implements PipeTransform {
  constructor(
  ) {}
  transform(bytes: number): string {
    if (!bytes) {
      return '0 B';
    }
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return ((bytes / Math.pow(1024, i)) as any).toFixed(2) * 1 + ' ' + sizes[i];
  }
}
